/**
 * Text mit Bild
 *
 * @package SSV Reutlingen 
 */

/**
 * Internal dependencies.
 */
 import Edit from './edit';

 /**
  * WordPress Dependencies.
  */ 
 import { registerBlockType } from '@wordpress/blocks';
 import { __ } from '@wordpress/i18n';
 import {
	 RichText,
 } from '@wordpress/block-editor';
 import { 
	pullLeft
} from '@wordpress/icons'; 
 /**
  * Register block type.
  */
 registerBlockType( 'ssvreutlingen-blocks/textimage', {
	 /**
	  * Block title.
	  *
	  * @type {string}
	  */
	 title: __( 'SSV Bild und Text', 'ssvreutlingen' ),
 
	 /**
	  * Block icon.
	  *
	  * @type {string}
	  */
	 icon: pullLeft,
 
	 /**
	  * Block description.
	  *
	  * @type {string}
	  */
	 description: __( 'Du kannst das Bild links oder rechts vom Text ausrichten.', 'ssvreutlingen' ),
 
	 /**
	  * Block category.
	  *
	  * @type {string}
	  */
	 category: 'ssvreutlingen',
     parent: "core/group",

	 /**
	  * Attributes.
	  */
	 attributes: {
		imageSrc: {
			type: 'object',
			selector: 'page__content-image-img',
		},
		altText: {
			selector: 'page__content-image-img',
			attribute: 'alt',
		},
		headline: {
			type: 'string',
			source: 'html',
			selector: 'h3',
			default: __( 'Überschrift', 'ssvreutlingen' ),
		},
		description: {
			type: 'string',
			source: 'html',
			selector: 'p',
			default: __( 'Beschreibung', 'ssvreutlingen' ),
		},
		mediaPosition: {
			type: 'string',
			default: 'left',
		},
	 },
 
	 edit: Edit,
 
	 /**
	  * Save function.
	  *
	  * @param {Object} props                    Props
	  *
	  * @param          props.attributes
	  * @param          props.attributes.content
	  * @return {Object} Content.
	  */
	 save( { attributes } ) {
		const {
			imageSrc,
			altText,
			headline,
			description,  
			mediaPosition,
		} = attributes;	
		const isLeft = mediaPosition === 'left';

		const ImageText = isLeft ? 'page__content -imagetext' : 'page__content -textimage';
		
		 return (
			<div className={ImageText}>
				<div className='page__content-image'>
					<div className='page__content-image-figure-wrap'>
						<figure className='page__content-image-figure'>
						
							<img className='page__content-image-img' src={ imageSrc ?  imageSrc.url : ''  } alt={ altText } />
						</figure>
					</div>
				</div>	
				<section className='page__content-text text'>
					<RichText.Content 
						value={ headline }
						tagName='h3'
					/>
					<RichText.Content 
						value={ description }
						tagName='p'  
					/>
				</section>
			</div>
		);
	 },
 } );
 